import { faEnvelope, faPhone } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';
import { Form } from 'react-bootstrap';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import Success_Lottie from '../animations/success_lottie/Success_Lottie';
import Profile_banner from '../common_components/common_banner/profile_banner/Profile_banner';
import Proceed_btn from '../common_components/common_btn/proceed_btn/Proceed_btn';
import Successfull_Modal from '../common_components/common_modal/successfull_modal/Successfull_Modal';
import './Contact_us.css';

function Contact_us() {
    const [phone, setPhone] = useState('');
    const [modalShow, setModalShow] = React.useState(false);
    return (
        <>
            <section className='Contact_us'>
                <Profile_banner imgSrc={"/assets/images/contact_us/bg.png"} heading={"CONTACT US"} subHeading={"Reach out to us anytime for support, feedback, or inquiries."} />

                <section className='profile_tabs_and_content '>
                    <div className="container">
                        <div className="row">
                            <div className="col-md-3 col-sm-4 mb-3">
                                <div className="section_holder">
                                    <div className="info_holder">
                                        <div className="heading_holder">
                                            <h6>GET IN TOUCH</h6>
                                            <p>Email & Contact Number</p>
                                        </div>

                                        <div className="info_text_holder">
                                            <div className="icon_text_holder">
                                                <div>
                                                    <div className="icon_holder">
                                                        <FontAwesomeIcon className='info_icon' icon={faEnvelope} />
                                                    </div>
                                                </div>
                                                <div className="text_holder">
                                                    <p>info@aiorigin.com</p>
                                                </div>
                                            </div>

                                            <div className="icon_text_holder">
                                                <div>
                                                    <div className="icon_holder">
                                                        <FontAwesomeIcon className='info_icon' icon={faPhone} />
                                                    </div>
                                                </div>
                                                <div className="text_holder">
                                                    <p>+91 6757732412/ <br /> +91 3647490950</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-9 col-sm-8 mb-3">
                                <div className="section_holder">
                                    <div className='Personal_details_tab_content'>
                                        <div className="profile_form_holder">
                                            <Form>
                                                <div className="row">
                                                    <div className="col-md-6">
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>First Name</Form.Label>
                                                            <Form.Control type="text" placeholder="Enter First Name" />
                                                        </Form.Group>
                                                    </div>

                                                    <div className="col-md-6">
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Last Name</Form.Label>
                                                            <Form.Control type="text" placeholder="Enter Last Name" />
                                                        </Form.Group>
                                                    </div>

                                                    <div className="col-md-6">
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Email</Form.Label>
                                                            <Form.Control type="email" placeholder="Enter Email" />
                                                        </Form.Group>
                                                    </div>

                                                    <div className="col-md-6">
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Mobile Number</Form.Label>
                                                            <PhoneInput
                                                                country={'us'}
                                                                value={phone}
                                                                onChange={(phone) => setPhone(phone)}
                                                            />
                                                        </Form.Group>
                                                    </div>

                                                    <div className="col-md-12">
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Your Message</Form.Label>
                                                            <Form.Control as="textarea" rows={3} placeholder="Enter Your Message" />
                                                        </Form.Group>
                                                    </div>

                                                    <div className="col-12 text-center mt-5">
                                                        <Proceed_btn btnText="Submit Now" onClick={() => setModalShow(true)} />
                                                    </div>
                                                </div>
                                            </Form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </section>
            <Successfull_Modal
                show={modalShow}
                message="Message Sent Successfully!"
                subMessage="Thank you for reaching out to us. Our team will get back to you shortly."
                onHide={() => setModalShow(false)}
                lottie={<Success_Lottie />}
            />
        </>
    )
}

export default Contact_us